class carouselExtNavCtrl {
  constructor($attrs, $element, $scope) {
    this.$attrs = $attrs;
    this.$scope = $scope;
    this.el = $element[0];
  }
  $postLink() {
    this.$attrs.$set('data-glide-el', 'controls');
  }
}
carouselExtNavCtrl.$inject = ["$attrs", "$element", "$scope"];
export default carouselExtNavCtrl;